module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-展开内容.5ab0a.png";